<script>
import Layout from '@layouts/main';
import ContactForm from '@views/contacts/form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEdit';

export default {
  name: 'ContactEdit',
  components: {
    Layout,
    ContactForm,
  },
  mixins: [beforeLeaveAfterEdit],
  page() {
    return {
      title: `${this.$t('titles.edit_contact')} #${this.$route.params.id}`,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.contacts'),
          to: { name: 'contacts.index' },
        },
        {
          text: `${this.$t('titles.edit_contact')} #${this.$route.params.id}`,
          active: true,
        },
      ],
    };
  },
  methods: {
    update() {
      this.setUnchanged();
      this.$router.push({
        name: 'contacts.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.edit_contact')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <ContactForm :loaded-id="$route.params.id" @submitted="update" @entity-changed="initBeforeLeave" />
    </b-card>
  </Layout>
</template>
